import { render } from "./SejourMedicalView.vue?vue&type=template&id=d833e2c4"
import script from "./SejourMedicalView.vue?vue&type=script&lang=js"
export * from "./SejourMedicalView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__